import { getProfileNameError } from "./profileName";

export const LANGUAGE_OPTIONS = [
  { value: "en", label: "English" },
  { value: "fr", label: "French" },
  { value: "pt", label: "Portuguese" },
  { value: "es", label: "Spanish" },
];

// What the Profile Settings dialog has to save. `initial` and `draft` are
// { name, language, timezone, isAutomaticTimezone }; localTimezone is the
// browser's zone name, used when "Set time zone automatically" is ticked.
export const getProfileSettingsChanges = (initial, draft, localTimezone) => {
  const name = (draft.name || "").trim();
  const nameChanged = name !== (initial.name || "").trim();
  const nameError = nameChanged ? getProfileNameError(name, initial.name) : "";

  const timezone = draft.isAutomaticTimezone ? localTimezone || initial.timezone : draft.timezone;
  const timezoneChanged =
    Boolean(draft.isAutomaticTimezone) !== Boolean(initial.isAutomaticTimezone) ||
    timezone !== initial.timezone;

  return {
    name,
    nameChanged,
    nameError,
    language: draft.language,
    languageChanged: draft.language !== initial.language,
    timezone,
    timezoneChanged,
    hasChanges: nameChanged || timezoneChanged || draft.language !== initial.language,
  };
};

// Body for PATCH /api/profile from the computed changes; null when only the
// language (browser-only) changed.
export const buildProfileSettingsPayload = (changes, isAutomaticTimezone) => {
  const payload = {};
  if (changes.nameChanged) payload.name = changes.name;
  if (changes.timezoneChanged) {
    payload.timezone = { timezonename: changes.timezone, isAutomaticTime: isAutomaticTimezone ? 1 : 0 };
  }
  return Object.keys(payload).length ? payload : null;
};

// The saved values from the PATCH response. GetDataWithErrors returns the
// envelope as-is, or GetData's wrapped shape after a token refresh.
export const readSavedProfileSettings = (res) => {
  const body = res?.response?.responseStatus ? res.response.response : res?.response;
  return { name: body?.name, timezone: body?.timezone };
};
